/**
 * profileService.js — Appels API du profil utilisateur
 */
import { authFetch, getAuthHeaders } from '../utils/authFetch';

/**
 * Enregistre des préférences du compte (fusion côté serveur : les clés
 * non envoyées sont conservées).
 * @param {Object} preferences ex. { horseListSort: 'nameAsc' }
 * @throws {Error} si le serveur refuse ou est injoignable
 */
export async function updatePreferences(preferences) {
  const res = await authFetch('/api/auth/profile', {
    method: 'PUT',
    credentials: 'include',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferences }),
  });
  const data = await res.json();
  if (!res.ok || !data.success) throw new Error(data.message || `HTTP ${res.status}`);
  return data.user?.preferences;
}
